<mat-card *ngIf="card.display != 'Off'" style="min-height: 100px; padding: 0; display: flex; flex-direction: row;">
    <div style="display: flex; flex-direction: column; flex: 1">
        <div class="header-color" style="display: flex; flex-direction: row;">
            <div class="robotoMedium" style="color: white; padding: 10px; font-size: 14pt; display: flex; flex-direction: column; flex: 1;">
                <span translate>Behavior</span>
            </div>
            <div style="display: flex; flex: 1; flex-direction: row;">
                <div style="display: flex; flex-direction: column; flex: 1; align-items: flex-end; padding-right: 5px; justify-content: center">
                    <button mat-stroked-button class="mat-card-button" (click)="viewBehaviorClick()"><span translate>Go To Behavior</span>
                    </button>
                </div>
            </div>
        </div>
        <div style="display: flex; flex-direction: row; flex: 1; flex-wrap: wrap; justify-content: center">
            <div style="display: flex;align-items: center;" *ngIf="behaviorEvents.length == 0">
                No Behavior data exists for student.
            </div>
            <div *ngIf="behaviorEvents.length > 0" style="display: flex; flex: 1">
                <mat-table style="width: 100%;" [dataSource]="behaviorEvents">
                    <!-- Date Column -->
                    <ng-container matColumnDef="date">
                        <mat-header-cell style="flex: 1.2;margin-right: 8px;min-width: 147px;" *matHeaderCellDef>Date</mat-header-cell>
                        <mat-cell style="flex: 1.2; align-items: start;margin-right: 8px;min-width: 147px;" *matCellDef="let element"> {{element.EventDate | date:'MM/dd/yy h:mm a'}} </mat-cell>
                    </ng-container>

                    <!-- Incident Column -->
                    <ng-container matColumnDef="incident">
                        <mat-header-cell style="flex: 2;margin-right: 8px;" *matHeaderCellDef>Incident</mat-header-cell>
                        <mat-cell style="flex: 2;margin-right: 8px; align-items: start" *matCellDef="let element">{{element.Incident}}</mat-cell>
                    </ng-container>

                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <mat-header-cell style="flex: 2" *matHeaderCellDef>Action</mat-header-cell>
                        <mat-cell style="flex: 2; align-items: start" *matCellDef="let element"> {{element.Action}} </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row style="align-items: flex-start;" *matRowDef="let row; columns: displayedColumns;"></mat-row>
                </mat-table>
            </div>
        </div>
    </div>
</mat-card>
